/**
 * @template T - type of item you set/get to web storage
 * base class for all web storage services
 */
export abstract class BaseWebStorage<T> {
    /**
     * key under which it will be stored
     */
    protected abstract key: string
    /**
     * browser storage instance, either localStorage or sessionStorage
     * @protected
     */
    protected storage: Storage
    constructor(
        /**
         * web storage type
         * @protected
         */
        protected storageType:
            | 'localStorage'
            | 'sessionStorage' = 'localStorage',
    ) {
        this.storage = window[storageType]
    }

    /**
     * get parsed item from web storage
     */
    abstract getItem(): T

    /**
     * set stringified item to web storage
     * @param item
     */
    abstract setItem(item: T): void

    /**
     * delete item with this service key from web storage
     */
    abstract removeItem(): void
}
